module.exports = __webpack_public_path__ + "72294db52f0438e22dab159553858afa.png";